module.exports = __webpack_public_path__ + "img/TALHADEIRA CURVA PONTA REDONDA  - desk.ae0edd03.png";